import { getDashboardPanels } from "@GeriMed/Services/DashboardService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { DashboardPanelModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Icon from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import List from "@insite/mobius/Icons/List";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
}

export enum PanelTypeValues {
    OrderApprovals = "orderapprovals",
    Requisitions = "requisitions",
    RequestForQuote = "requestforquote",
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
});

type Props = ReturnType<typeof mapStateToProps> ;

const DashboardPanel: FC<Props> = ({
    session,
}) => {
    const [panels , setPanels]  = useState([] as DashboardPanelModel[]);

    useEffect(() => {
        getDashboardPanels()
        .then(result => {
            if(result && result.dashboardPanels)
            {setPanels(result?.dashboardPanels.filter((x) => { return x.isPanel; }));}
        });
    }, []); 

    const getCssClass = (panelType: string): string =>{
        if (panelType.toLocaleLowerCase() === PanelTypeValues.OrderApprovals) {
            return "db-li-oapp";
        }
        if (panelType.toLocaleLowerCase() === PanelTypeValues.Requisitions) {
            return "db-li-req";
        }
        if (panelType.toLocaleLowerCase() ===  PanelTypeValues.RequestForQuote) {
            return "db-li-quotes";
        }
        return "";
    }

        return (
            <>
            { panels && panels.length > 0 && (
                <ul className="dashboard-pannel">
                {panels.map((panel, index) => (
                    <li key={index} className={getCssClass(panel.panelType)} >
                        <a href={panel.url}>
                            <span className="pannel-icon oapp-icon">
                                <Icon size={40} src={File} />
                            </span>
                            <span className="pannel-icon req-icon">
                                <Icon size={40} src={List} />
                            </span>
                            <span>{panel.text}</span>
                        </a>
                        <label>{panel.count}</label>
                    </li>
                ))}
            </ul>
           )}
            </>
        );

};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(DashboardPanel),
    definition: {
        displayName: "DashboardPanel",
        icon: "cart-shopping",
        group: "Common",
    },
};

export default widgetModule;
function componentDidMount() {
    throw new Error("Function not implemented.");
}

